import { createApp } from 'vue'

import ReviewDocumentForm from '@/src/javascripts/document/ReviewDocumentForm.vue'
import BaseAlert from '@/src/vueComponent/BaseAlert.vue'

$(document).on('turbo:load turbo:render', () => {
  const reviewDocumentForm = document.querySelector('#review-document-form')

  if (reviewDocumentForm && !reviewDocumentForm.__vue_app__) {
    const app = createApp({
      components: { ReviewDocumentForm, BaseAlert }
    })

    app.mount(reviewDocumentForm)
  }
})
